export class Law {
    get id() {
        return this.lawState.id;
    }
    get law() {
        return this.lawState.law;
    }
    get description() {
        return this.lawState.description;
    }
    set law(law) {
        this.lawState.law = law;
    }
    set description(description) {
        this.lawState.description = description;
    }
    constructor(lawState) {
        this.lawState = lawState;
    }
    getState() {
        return this.lawState;
    }
}
